import React from "react";
import FileItem from "./FileItem";
import { ListGroup } from "reactstrap";

const FileList = ({ files, ...props }) => {
    return (
        <ListGroup>
            {files.map((file) => (
                <FileItem key={file.id} file={file} {...props} />
            ))}
        </ListGroup>
    );
};

export default FileList;
